const KEY = "brewer-intro-seen";
const seen = typeof window !== "undefined" && sessionStorage.getItem(KEY) === "1";

export const SHOW_INTRO = !seen;
export const INTRO_DELAY = seen ? 0 : 2.1;
export const markIntroSeen = () => sessionStorage.setItem(KEY, "1");
